import * as React from "react";
import styled from "styled-components";
import * as rootStyles from "../../styles";
import { LARGE_SCREEN_WIDTH_THRESHOLD } from "../../../utils";
import { LargeSolidButton } from "./input";

const DISMISS_FOOTER_HEIGHT = 76;

export type StickyDismissFooterProps = {
    title: string;
    onClick: () => void;
    id: string;
};

export const StickyDismissFooter: React.FC<StickyDismissFooterProps> = ({
    title,
    onClick,
    id,
}) => {
    return (
        <FooterContainer>
            <LargeSolidButton
                title={title}
                onClick={onClick}
                id={id}
                containerStyle={{ width: "100%" }}
            />
        </FooterContainer>
    );
};

const FooterContainer = styled.div`
    display: none;
    @media (max-width: ${LARGE_SCREEN_WIDTH_THRESHOLD}px) {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: ${DISMISS_FOOTER_HEIGHT}px;
        align-items: center;
        justify-content: center;
        padding: 0 ${rootStyles.spacers.base}px;
        background: ${rootStyles.colors.background};
        z-index: 10;
    }
`;

export { DISMISS_FOOTER_HEIGHT };
